import { useState } from "react";
import { Check, PencilLine, Leaf } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Section } from "@/components/analysis/resultUi";

function CorrectForm({ a, reload, onCancel }) {
  const [common, setCommon] = useState("");
  const [botanical, setBotanical] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    setBusy(true);
    await api.post(`/analyses/${a.id}/species`, { choice: "modifica", common_name: common, botanical_name: botanical }).catch((err) => toast.error(errMsg(err)));
    setBusy(false);
    reload();
  };
  return (
    <form onSubmit={send} className="mt-3 space-y-3" data-testid="species-correct-form">
      <input className="field !text-base" placeholder="Nome comune (es. arancio amaro)" value={common} onChange={(e) => setCommon(e.target.value)} data-testid="species-correct-common-input" />
      <input className="field !text-base" placeholder="Nome botanico, se lo conosci" value={botanical} onChange={(e) => setBotanical(e.target.value)} data-testid="species-correct-botanical-input" />
      <p className="text-[15px] leading-relaxed text-[#5b6b60]">L'analisi verrà aggiornata con la specie corretta, senza un nuovo addebito.</p>
      <div className="flex gap-2">
        <button type="submit" disabled={busy || !(common.trim() || botanical.trim())} className="btn-primary min-h-[48px] flex-1 !text-base" data-testid="species-correct-submit">Aggiorna l'analisi</button>
        <button type="button" onClick={onCancel} className="btn-secondary min-h-[48px] bg-white !text-base" data-testid="species-correct-cancel">Annulla</button>
      </div>
    </form>
  );
}

export default function SpeciesConfirm({ a, reload }) {
  const [editing, setEditing] = useState(false);
  const sp = a.species || {};
  if (a.species_confirmation === "si" || sp.user_confirmed) {
    return <p className="flex items-center gap-2 text-[16px] text-[#15803D]" data-testid="species-confirmed"><Check size={18} /> Specie confermata: {sp.common_name} <span className="botanical">{sp.botanical_name}</span></p>;
  }
  if (a.species_confirmation === "modifica") return null;
  const confirm = async () => {
    await api.post(`/analyses/${a.id}/species`, { choice: "si" }).catch((e) => toast.error(errMsg(e)));
    reload();
  };
  return (
    <Section icon={Leaf} title="È questa la tua pianta?" testid="species-confirm">
      <p className="text-[17px] leading-relaxed text-[#2D3A30]">Ho riconosciuto: <strong>{sp.common_name || "agrume"}</strong> <span className="botanical text-[#B39257]">{sp.botanical_name}</span></p>
      {!editing ? (
        <div className="mt-3 flex gap-2">
          <button onClick={confirm} className="btn-primary min-h-[48px] flex-1 !text-base" data-testid="species-confirm-yes"><Check size={18} /> Sì, è corretta</button>
          <button onClick={() => setEditing(true)} className="btn-secondary min-h-[48px] flex-1 bg-white !text-base" data-testid="species-confirm-edit"><PencilLine size={18} /> Correggi</button>
        </div>
      ) : <CorrectForm a={a} reload={reload} onCancel={() => setEditing(false)} />}
    </Section>
  );
}
